var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.36975C19 3.85048 19 3.59084 18.8922 3.47061C18.7986 3.3663 18.6583 3.31093 18.5147 3.3217C18.3492 3.3341 18.1564 3.51769 17.7709 3.88487L14.5 7L17.7709 10.1151C18.1564 10.4823 18.3492 10.6659 18.5147 10.6783C18.6583 10.6891 18.7986 10.6337 18.8922 10.5294C19 10.4092 19 10.1495 19 9.63025V4.36975Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.11429C1 3.67415 1 2.95408 1.29428 2.40402C1.55314 1.92018 1.96619 1.5268 2.47423 1.28027C3.05179 1 3.80786 1 5.32 1H10.18C11.6921 1 12.4482 1 13.0258 1.28027C13.5338 1.5268 13.9469 1.92018 14.2057 2.40402C14.5 2.95408 14.5 3.67415 14.5 5.11429V8.88571C14.5 10.3258 14.5 11.0459 14.2057 11.596C13.9469 12.0798 13.5338 12.4732 13.0258 12.7197C12.4482 13 11.6921 13 10.18 13H5.32C3.80786 13 3.05179 13 2.47423 12.7197C1.96619 12.4732 1.55314 12.0798 1.29428 11.596C1 11.0459 1 10.3258 1 8.88571V5.11429Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcVideo);
export default __webpack_public_path__ + "static/media/pc-video.84e29c4544f8d90be6e403d3aa902f69.svg";
export { ForwardRef as ReactComponent };